<template lang="pug">
  div()
    app-header(:white='true' class='u-absolute')

    section(class='u-flex u-items-center o-container u-min-height-100vh' style='background-size:cover;background-position: 0% 100%;background-image: url(/images/home.jpg)')
      div(class='o-wrapper u-py3 u-flex  u-items-center u-flex-wrap u-justify-between')
        div(class='u-py3  u-6/12@tablet u-12/12')
          h2(class='u-line-1' data-aos="fade-right")
            span(class='u-fz-h2 u-white u-fw-light u-block') Seria, Responsable
            span(class='u-fz-h0 u-block u-white u-fw-bold') de mucha
            span(class='u-fz-h0 u-block u-color-secondary u-fw-bold ') Confianza.

          p(class='u-white u-fz-h4' data-aos="fade-right")
            span(class='u-fw-bold u-uppercase') Instale la aplicación&nbsp;
            span(class='u-color-text') en tu móvil y vive
            span(class='u-block u-color-text') tu experiencia en Tacna con Pavill.

          router-link(:to="{ name: 'App'}" data-aos="fade-right" class='u-inline-flex u-items-center u-fw-bold u-uppercase c-btn--primary') Descargar App
          //- button(class='u-fw-bold u-uppercase c-btn--primary') Descargar App

        div(class='u-py3 ')
          button(class='u-color-secondary c-video-play'  data-aos="fade-left" @click='isShowModalVideo = true' v-if='company.homeVideo')
            i(class='u-icon') video

    section(class='u-bg-degradent o-container u-white u-pt5 u-pb4')
      h3(class='u-white u-mt0 u-mb3 u-fz-h2 u-center u-line-1'  data-aos="fade-up")
        span(class=' u-inline-block u-fw-light') ¿Qué&nbsp;
        span(class='u-inline-block') Servicios&nbsp;
        span(class='u-inline-block u-fw-light') deseas hoy?

      p(class='u-mt0 u-center u-mb4'  data-aos="fade-up") Varios tipos de vehículos a tu disposición para tu ubicación y necesidades.

      ul(class='u-list-none u-flex u-justify-center u-flex-wrap u-mb0 u-pl0')
        li(class='u-mb4 u-mt3 u-px3' v-for='service in services'  data-aos="fade-up")
          button(class='c-service', :style='{backgroundColor: service.color}' @click='showModalService(service.id)') {{service.name}}
            //- img(src='/images/service.svg' class='c-service__image')
            span(class='c-service__image u-icon service', :style='{color: service.color}' )

    section(class='u-bg-secondary u-pt5')
      div(class=' u-justify-between u-flex  u-flex-wrap o-wrapper')
        div(class='u-4/12@laptop  u-12/12 u-mb4')
          p(class='u-fz-h1 u-mt0  u-mb0 u-white u-line-1'  data-aos="fade-right")
            strong Pide
            span(class='u-block u-fw-light') un {{company.name}}

          figure( data-aos="fade-right" class='u-ml0 u-mr0')
            img(src='/images/car.png')

        ul(class='u-flex u-list-none u-flex-wrap u-6/12@laptop u-12/12 u-pl0 u-m0 u-justify-center')
          li(class='u-px4 u-mb5 u-6/12@tablet'  data-aos="fade-left")
            figure(class='u-mt0 u-mb0 u-mx-auto' style='width: 250px')
              img(src='/images/cellphone.png')

            p(class='u-center u-white u-mb0')
              span(class='u-fw-light u-fz-h4') Descarga nuestra&nbsp;
              strong(class='u-fz-h4') aplicación móvil para android


          li(class='u-px4 u-mb5 u-6/12@tablet'  data-aos="fade-left")
            figure(class='u-mt0 u-mb0 u-mx-auto' style='width: 250px')
              img(src='/images/call.png')

            p(class='u-center u-white u-mb0')
              span(class='u-fw-light u-fz-h4') Llamar al
            p(class='u-center u-white u-mb0 u-mt0')
              strong(class='u-fz-h4') {{company.phone}}
            p(class='u-center u-white u-mb0 u-mt0')
              span(class='u-fw-light u-fz-h4') o al whatsapp
            p(class='u-center u-white u-mb0 u-mt0')
              strong(class='u-fz-h4') {{company.cellphone}}

    figure(class='u-m0 u-show@tablet')
      img(src='/images/border-bottom.png' class='u-12/12')

    section(class='o-wrapper u-py5')
      h2(class='u-center u-fz-h1 u-line-1 u-mt3' data-aos="fade-up")
        span(class='u-block u-fw-light') Marcamos la
        strong(class='u-block u-color-secondary') Diferencia

      swiper(:options='swiperFeatures' class='u-12/12')
        swiper-slide(v-for='(feature, index) in features', :key='index' style='height:auto' class='u-flex'  data-aos="fade-up")
          div(class='c-feature u-flex-1')
            figure(class='u-mt0 u-mb0 u-mx-auto u-px3' style='width:80px')
              img(:src='feature.imageUrl')
            p(class='u-fw-bold u-uppercase u-color-primary') {{feature.title}}
            p(class='u-color-tex u-mb0') {{feature.description}}


    //- router-link(:to="{ name: 'Reports'}" class='u-block'  data-aos="fade-up")
    <a href='https://reporta.pavill.com/' :target="hrefTarget">
          img(src='/images/report.jpg' class='u-block u-12/12')
    </a>
    section(class='u-bg-primary u-py5' v-if='testimonies.length > 0')
      div(class='u-relative o-wrapper u-my4')
        swiper(:options='swiperTestimonies' class='u-12/12')
          swiper-slide(v-for='(testimony, index) in testimonies', :key='index' class='u-center o-container')
            p(class='u-fz-h3 u-fw-bold u-white u-mt0 u-mb3') {{testimony.name}}
            p(class='u-color-text u-mb0') {{testimony.content}}

        button(class="c-btn-nav c-btn-nav--prev c-btn-nav--white" id="testimony-prev")
          i(class='u-icon') arrow_left
        button(class="c-btn-nav c-btn-nav--next c-btn-nav--white" id="testimony-next")
          i(class='u-icon') arrow_right

    section(class='u-bg-secondary u-py5 o-container')
      div( data-aos="fade-up" class='u-flex u-flex-wrap u-br8 u-overflow-hidden u-justify-center u-mx-auto' style='width: 850px;max-width:100%')
        div(class='u-bg-border u-px4 u-py4 u-4/12@laptop u-12/12 u-flex u-justify-center u-flex-column')
          p(class='u-fw-bold u-line-1 u-color-primary u-fz-h3 u-uppercase u-mt0') Síguenos en
            span(class='u-block') Facebook

          p(class='u-fw-s-bold u-mb2') Compartir en:
          a(class='c-btn-share u-bg-primary', :href='company.facebookPage' target='_blank')
            i(class='u-icon') facebook
        div(class='u-bg-white u-py4 u-px3 u-flex-1')
          iframe(class='u-mx-auto u-block u-facebook', :src="faceWeb" width="500" height="200" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true")


    section(class='u-pt5 u-pb4 u-bg-landscape' v-if='company && company.parnerts.length > 0')
      h3(class='u-fz-h2 u-center u-mt0 u-line-1 o-wrapper u-mb5')
        span(class='u-color-secondary') Trabajamos juntos&nbsp;
        span(class='u-color-primary') para un mejor servicio

      ul(class='u-flex u-flex-wrap u-pl0 u-list-none u-mb0 o-wrapper u-justify-center')
        li(v-for='parnert in company.parnerts' class='u-px4 u-mb4')
          a(style='height:60px' class='u-m0 u-block', :href='parnert.link' target='_blank')
            img(:src='parnert.imageUrl', :title='parnert.title' style='max-height:100%')

    app-footer

    modal-delivery(v-if='isShowModalDelivery' @hide='isShowModalDelivery = false' @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-express(v-if='isShowModalExpress' @hide='isShowModalExpress = false' @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-radio-taxi(v-if='isShowModalRadioTaxi' @hide='isShowModalRadioTaxi = false' @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-tourism(v-if='isShowModalTourism' @hide='isShowModalTourism = false' @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-woman-taxi(v-if='isShowModalWomanTaxi' @hide='isShowModalWomanTaxi = false' @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-video(:url='company.homeVideo' v-if='isShowModalVideo' @hide='isShowModalVideo = false' @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-confirm(v-if='isShowModalConfirm' @hide='isShowModalConfirm = false')
    modal-error(v-if='isShowModalError' @hide='isShowModalError = false')
</template>

<script>
  import ModalExpress from 'components/ModalExpress'
  import ModalDelivery from 'components/ModalDelivery'
  import ModalRadioTaxi from 'components/ModalRadioTaxi'
  import ModalTourism from 'components/ModalTourism'
  import ModalWomanTaxi from 'components/ModalWomanTaxi'
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'HomeScreen',
    components: {
      ModalExpress,
      ModalWomanTaxi,
      ModalDelivery,
      ModalTourism,
      ModalRadioTaxi
    },
    data () {
      return {
        isShowModalError: false,
        isShowModalConfirm: false,
        isShowModalDelivery: false,
        isShowModalExpress: false,
        isShowModalRadioTaxi: false,
        isShowModalTourism: false,
        isShowModalWomanTaxi: false,
        isShowModalVideo: false,
        selectedService: 0,
        swiperTestimonies: {
          slidesPerView: 1,
          prevButton: '#testimony-prev',
          nextButton: '#testimony-next'
        },
        testimonies: [],
        swiperFeatures: {
          slidesPerView: 5,
          autoplay: 5000,
          breakpoints: {
            889: {
              slidesPerView: 4
            },
            778: {
              slidesPerView: 3
            },
            560: {
              slidesPerView: 2
            },
            320: {
              slidesPerView: 1
            }
          }
        },
        features: [
          {
            id: 1,
            title: 'Buen trato al cliente',
            imageUrl: '/images/icon1.png',
            description: 'Atención personalizada en el servicio y buen trato al cliente, siempre con responsabilidad, respeto y honradez.'
          },
          {
            id: 2,
            title: 'Flota moderna',
            imageUrl: '/images/icon2.png',
            description: 'Pavill cuenta con vehículos modernos para brindar comodidad en su trayectoria, seguridad y confort.'
          },
          {
            id: 3,
            title: 'Conductores con experiencia',
            imageUrl: '/images/icon3.png',
            description: 'Nuestros conductores cuentan con amplia experiencia y están en constante capacitación.'
          },
          {
            id: 4,
            title: 'Central telefónica moderna',
            imageUrl: '/images/icon4.png',
            description: 'Central telefónica moderna disponible las 24 horas del día, envio de taxi a domicilio y delivery.'
          },
          {
            id: 5,
            title: 'Servicio de taxi por App',
            imageUrl: '/images/icon5.png',
            description: 'Para un servicio más rápido, confiable, y personal, le ofrecemos el servicio de aplicación desde su celular.'
          }
        ],
        services: []
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      }),

      faceWeb () {
        if (this.company.facebookPage) {
          return `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(this.company.facebookPage)}&tabs=timeline&width=500&height=200&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
        }
        return ''
      }
    },

    methods: {
      getTestimonies () {
        axios.get(`${window.API_URL}/testimonies`)
          .then(({data}) => {
            this.testimonies = data.data
          })
      },

      getServices () {
        axios.get(`${window.API_URL}/services`)
          .then(({data}) => {
            this.services = data.data
          })
      },

      showModalService (id) {
        this.selectedService = id
        switch (id) {
          case 1:
            this.isShowModalWomanTaxi = true
            break
          case 2:
            this.isShowModalExpress = true
            break
          case 3:
            this.isShowModalTourism = true
            break
          case 4:
            this.isShowModalRadioTaxi = true
            break
          case 5:
            this.isShowModalDelivery = true
            break
          default:
        }
      }
    },

    created () {
      this.getTestimonies()
      this.getServices()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Home/components/HomeScreen.vue